import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, list_type, int32_type, class_type, union_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Help_Ansprechpartner_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { Remote$1, Remote$1_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { empty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";

export class Page extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Kontakt"];
    }
}

export function Page_$reflection() {
    return union_type("Help.Types.Page", [], Page, () => [[]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadAnsprechpartner", "AnsprechpartnerLoaded", "Toggle"];
    }
}

export function Msg_$reflection() {
    return union_type("Help.Types.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Help_Ansprechpartner_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Help_Ansprechpartner_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [["i", int32_type]]]);
}

export class Model extends Record {
    constructor(Ansprechpartner, Touched, Expanded) {
        super();
        this.Ansprechpartner = Ansprechpartner;
        this.Touched = Touched;
        this.Expanded = Expanded;
    }
}

export function Model_$reflection() {
    return record_type("Help.Types.Model", [], Model, () => [["Ansprechpartner", Remote$1_$reflection(Help_Ansprechpartner_$reflection())], ["Touched", list_type(int32_type)], ["Expanded", list_type(int32_type)]]);
}

export function Model_Init() {
    return new Model(new Remote$1(1, []), empty(), empty());
}

//# sourceMappingURL=Types.fs.js.map
